import type { UserProfile } from "../profile/schemas";

/** The profile fields the Overview asks a new attendee to fill in. */
export type MissingProfileField = "photo" | "job title" | "company";

function blank(value: string | undefined): boolean {
  return value === undefined || value.trim() === "";
}

/** What an attendee's profile lacks of the three things the directory shows. */
export function missingProfileFields(
  profile: Pick<UserProfile, "jobTitle" | "company" | "avatar">,
): MissingProfileField[] {
  const missing: MissingProfileField[] = [];
  if (blank(profile.avatar)) missing.push("photo");
  if (blank(profile.jobTitle)) missing.push("job title");
  if (blank(profile.company)) missing.push("company");
  return missing;
}

/** "photo", "photo and company", "photo, job title and company". */
export function joinFields(fields: MissingProfileField[]): string {
  if (fields.length <= 1) return fields.join("");
  return `${fields.slice(0, -1).join(", ")} and ${fields[fields.length - 1]}`;
}

/** Per person, not per event: someone who said "not now" is not asked again. */
export function profilePromptKey(uid: string): string {
  return `hb-profile-prompt-dismissed:${uid}`;
}

export function profilePromptDismissed(uid: string): boolean {
  try {
    return window.localStorage.getItem(profilePromptKey(uid)) === "1";
  } catch {
    // Private windows and blocked site data throw. Ask again rather than hide
    // the prompt for good.
    return false;
  }
}

export function dismissProfilePrompt(uid: string): void {
  try {
    window.localStorage.setItem(profilePromptKey(uid), "1");
  } catch {
    // Not saved: the card is hidden for this visit only, through its own state.
  }
}
